<template>
    <a-modal v-model:visible="modalConfig.visible" :title="modalConfig.title" @ok="handleOk" @cancel="handleCancel"
        :footer="null" width="800px">


        <div class="preview-page" v-if="perviewContent" v-html="perviewContent">

        </div>
    </a-modal>
</template>

<script>
import { defineComponent, reactive, ref } from "vue";

export default defineComponent({
    setup() {
        const modalConfig = reactive({
            visible: false,
            title: null,
        });

        const perviewContent = ref(null);

        const showModal = (content) => {
            modalConfig.title = '预览'
            modalConfig.visible = true;
            perviewContent.value = content;
        };



        const handleCancel = () => {
            perviewContent.value = null;
        };

        return {
            perviewContent,
            modalConfig,
            showModal,
            handleCancel
        };
    },
});
</script>

<style lang="less" scoped>
.preview-page {
    width: 750px;
    height: 75vh;
    overflow-y: scroll;
    :deep(img) {
        width: 700px;
        height: auto;
    }

    :deep(video) {
        width: 700px;
        border-radius: 20px;
    }
}
</style>